import React from 'react';
import { Box, Typography, Paper, Grid, Card, CardContent } from '@mui/material';

const DisbursementHistory = ({ disbursements }) => {
  if (!disbursements || disbursements.length === 0) return null;

  return (
    <Paper sx={{ p: 3, mt: 3 }}>
      <Typography variant="h5" gutterBottom>Disbursement History</Typography>
      <Grid container spacing={2}>
        {disbursements.map((disbursement) => (
          <Grid item xs={12} key={disbursement.id}>
            <Card variant="outlined">
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                  <Box>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {disbursement.room_name} - {disbursement.item_title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Disbursed by: {disbursement.disbursed_by_name}
                    </Typography>
                    {disbursement.check_number && (
                      <Typography variant="body2" color="text.secondary">
                        Check #: {disbursement.check_number}
                      </Typography>
                    )}
                    {disbursement.notes && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {disbursement.notes}
                      </Typography>
                    )}
                    <Typography variant="caption" color="text.secondary">
                      {new Date(disbursement.created_at).toLocaleDateString()} at{' '}
                      {new Date(disbursement.created_at).toLocaleTimeString()}
                    </Typography>
                  </Box>
                  <Typography variant="h6" color="success.main">
                    ${parseFloat(disbursement.amount).toLocaleString()}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default DisbursementHistory;
